module.exports = __webpack_public_path__ + "static/media/slide-1.7e1db0da.jpg";